import styled from 'styled-components';

export const DropContainer = styled.div`
  display: flex;
  column-gap: 10px;
  min-height: 265px;
`;
